export default __webpack_public_path__ + "static/media/cloud-upload-24.d61a213a.svg";